import script from "./CoacheSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CoacheSlider.vue?vue&type=script&setup=true&lang=js"

import "./CoacheSlider.vue?vue&type=style&index=0&id=d06cbef0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d06cbef0"]])

export default __exports__